import logo from "../Assets/Logos/logo_BRK.svg";
import { LoadingSquare } from "../Styles/loading";

export const SquareLoading = () => {
  return (
    <LoadingSquare className="notPri">
      <img src={logo} alt="" />
      <span className="loaderSquare">
        <span className="loaderSquare-inner"></span>
      </span>
      <h3>Loading...</h3>
    </LoadingSquare>
  );
};
